<template>
    <div class="nine-dots align-self-center" v-if="hasMktIt">
        <b-button :id="buttonId" href="#" tabindex="0" variant="link">
            <svg style="height: 1.6rem" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect y="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="26" y="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="13" y="26" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect y="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="26" y="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
                <rect x="13" y="13" width="10" height="10" rx="2" fill="#9E9D9D"/>
            </svg>
        </b-button>

        <b-popover
          :id="popoverId"
          :target="buttonId"
          placement="bottomleft"
          :triggers="popoverTrigger"
          custom-class="border-0 shadow nine-dots-popup">

            <div class="p-4 d-flex flex-column nine-dots-list">
                <p class="app-group-label">Business</p>
                <a href="/"  target="_blank" v-if="hasDealerRole">
                  <img src="/img/SmartPlanner_01.png" alt="">
                  <span>Licenze</span>
                </a>
            </div>

            <div class="px-5 py-2 text-center bg-light rounded-bottom">
                <a class="" href="https://oneplus.italretail.it">
                    <img src="/img/login-logo.svg" alt="" style="height: 24px;">
                    <span class="ml-2 text-black">oneplus.italretail.it</span>
                </a>
            </div>

        </b-popover>

    </div>
</template>
<script>


    export default {
        name: 'nine-dots',
        components: {},
        props: {
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        computed: {
          popoverTrigger() {
            return this.isMobile ? 'click' : 'hover';
          },
          buttonId() {
            return this.isMobile ? 'button-link-mobile' : 'button-link'
          },
          popoverId() {
            return 'popover-' + this.buttonId;
          },
          isCustomerGroup() {
              return this.$store.getters['account/group'] === 'customer'
          },
          isDealerGroup() {
            return this.$store.getters['account/group'] === 'dealer'
          },
          hasCustomerRole() {
            return this.$store.getters['account/oidc']?.role?.includes('Customers')
          },
          hasDealerRole() {
            return this.$store.getters['account/oidc']?.role?.includes('Dealers')
          },
          authUrl() {
            return  this.$store.getters.getAuthUrl;
          },
          isProfilePageLinkVisible() {
            if (!this.authUrl) return false;

            return this.isCustomerGroup || this.isDealerGroup;
          },
          hasMktIt() {
            return this.$store.getters?.getAcls?.includes('mkt_it');
          },
          hasDistributor() {

            return this.$store.getters.getDealer?.has_distributor;
          },
          hasDealer() {
            return this.$store.getters.getDealer;
          }
        },
        methods: {
            handleRchDomain(url) {
                    return url
            }
        },

    }
</script>
